/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "UlIDxrK43ko",
    title: "What's on My Bookshelf (2022)",
    description:
      "This video is a not-so-little talk through every single book on my bookshelf... Enjoy the ride, and let me know in the comments which one of these books you like the most.",
    creator: "Ali Abdaal",
    category: "Self-Help"
  },
  {
    _id: "ipdKXJcjP24",
    title: "read a book a week for a year and changed my life",
    description:
      "My goodreads & book recommendations: https://www.goodreads.com/user/show/1...",
    creator: "Elena Taber",
    category: "Self-Help"
  },
  {
    _id: "wlvxviP-xNg",
    title: "8 Lessons I Learned From Elon Musk",
    creator: "Ali Abdaal",
    description:
      "In this video, we're going over 8 life lessons I learned from Elon Musk. Some are related to productivity, and others are about living a good life in general. If you're interested in learning more about Elon, his biography by Ashley Vance is a pretty good read. ",
      category: "Non-Fiction"
  },
  {
    _id: "AUw7laSlcbo",
    title: "Reading Changes your Brain, let me explain.",
    creator: "Jack Close",
    description:
      "Reading changes your brain... I'll take you through the neuroscience of reading books and how it is changing the way your brain works!",
      category: "Self-Help"
  },
  {
    _id: "lCrMAtbBUJA",
    title: "15 Books To Read In 2022",
    creator: "Ali Abdaal",
    description:
      "In this video, I talk through 15 of my favourite books that I read in 2021. If you're looking for some recommendations for the New Year, I'd 100% recommend everything on this list. Enjoy! ",
      category: "Self-Help"
  },
  {
    _id: "VXkJnuu2iYE",
    title: "7 Books EVERYONE in Their 20's Should Read",
    creator: "Thomas Frank",
    description:
      "Essential reads for your career, finances, productivity, and more.",
      category: "Self-Help"
  },
  {
    _id: "s6fye8WwN_4",
    title: "20 Books to read in your 20s",
    creator: "Ankur Warikoo",
    description:
      "All the answers and wisdom of the world are contained in #books. I’m so so grateful to my parents for building this habit of reading in me, it has shaped me up a lot. A lot.I want to share a list of 20 books that you must read in your 20’s. They are ranging from knowing about introversion, autobiographies of people who rose higher from very humble beginnings, being the indispensable person in your organisation, witnessing death of a withering loved one to witnessing massive deaths, writing cold emails, understanding our civilization, understanding why we do what we do, opening up to a whole new growth mindset, and many many more!",
      category: "Self-Help"
  },
  {
    _id: "NSl-MGN-2Es",
    title: "Books that changed our lives",
    creator: "Abhi and Niyu",
    description:
      "In this video, Abhi and Niyu recommend 5 books that have made an impact on their lives. These books are great for beginners to explore some new ideas and work on them.",
      category: "Non-Fiction"
  },
  {
    _id: "UOm8fJAdMig",
    title: "5 books that are for EVERYONE",
    creator: "Ankur Warikoo",
    description:
      "From changing your beliefs to knowing the deepest truths about money to not giving a damn to what other people think to a compilation of multiple books into one! These books have changed the way I operate, and thankfully so! If you want to change the way you operate, read, re-read and apply the learnings in these books. And you won’t regret a dime!",
      category: "Self-Help"
  },
  {
    _id: "TLZr5GVeLcY",
    title: "Is Reading Fiction Books Good for You?",
    creator: "Ali Abdaal",
    description:
      "Hey guys, today we're taking a look at whether reading fiction can bring any tangible benefits.",
      category: "Fiction"
  },
  {
    _id: "WJxo_3P2FZM",
    title: "12 books you need to read in 2022 *fiction*",
    creator: "Jack Edwards",
    description:
      "these are my top top top books of the year (links below) out of the 164 that i read in 2021, as well as a quote from each one to give you a little teaser!!",
      category: "Fiction"
  },
  {
    _id: "xN9j4oNSFQ4",
    title: "Must Read Fiction Books",
    creator: "The Book Show",
    description:
      "We have read many fiction books this year and reviewed it. We are proud to present a recap of all the fiction books we have reviewed this year. Watch the full video and get a quick glimpse about these books ft. RJ Ananthi. Also click the playlist link to see the full length reviews of these books.",
      category: "Fiction"
  },
];
